var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"shapeRendering":"geometricPrecision","d":"M45.6 35.1l1.621-9.558H37.074V19.34c0-2.614 1.417-5.163 5.962-5.163h4.614V6.041s-4.187-.646-8.19-.646c-8.358 0-13.82 4.577-13.82 12.863v7.284h-9.29V35.1h9.29v23.103c1.863.264 3.772.402 5.717.402 1.945 0 3.854-.138 5.717-.402V35.1h8.525z","fill":"currentColor","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Facebook;

Facebook.default = Facebook;
